import type { JSX } from "react";
import { cn } from "./cn";

type EpisodeStatus = "active" | "needs_input" | "idle" | "archived" | "completed";

const STATUS_CONFIG: Record<EpisodeStatus, { label: string; className: string }> = {
  active: { label: "Active", className: "bg-blue-500/15 text-blue-400" },
  needs_input: { label: "Needs input", className: "bg-amber-500/15 text-amber-400" },
  idle: { label: "Idle", className: "bg-surface-hover text-content-tertiary" },
  archived: { label: "Archived", className: "bg-surface-hover text-content-tertiary" },
  completed: { label: "Done", className: "bg-emerald-500/15 text-emerald-400" },
};

export interface StatusBadgeProps {
  readonly status: string | undefined;
  readonly className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const config = STATUS_CONFIG[(status ?? "active") as EpisodeStatus] ?? STATUS_CONFIG.active;

  return (
    <span
      className={cn(
        "text-[10px] rounded-full px-1.5 py-0.5 shrink-0",
        config.className,
        className,
      )}
    >
      {config.label}
    </span>
  );
}
